<template>
  <div id="HomeBox">
    <el-container>
      <el-aside :width="collapse ? '64px' : '240px'">
        <el-header style="padding: 0">
          <Logo></Logo>
        </el-header>
        <AsideMenu></AsideMenu>
      </el-aside>
      <el-container class="BoxRight">
        <el-header class="BoxRightHeader">
          <Header></Header>
        </el-header>
        <el-main>
          <router-tab />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import AsideMenu from "./AsideMenu";
import Logo from "./Logo.vue";
import Header from "./Header";
export default {
  components: {
    AsideMenu,
    Logo,
    Header,
  },
  data() {
    return {};
  },
  computed: {
    collapse() {
      return this.$store.state.IsCollapse;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/themes/common";

#HomeBox {
  //在此使用了背景颜色变量
  @include background_color("bg_color");
  @include font_color("text-color");
  transition: background 1s, color 0.6s;
  height: 100%;
  .el-main {
    padding: 0;
  }
  .el-container {
    height: 100vh;
    overflow: hidden;
  }
}
</style>